import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Services from "./sections/Services";
import TheDirectorsPath from "./sections/TheDirectorsPath";
import Packages from "./sections/Packages";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Services />
      <TheDirectorsPath />
      <Packages />
      <Footer />
    </div>;
}